// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BeRV","importantInfo":"styles_importantInfo__2l4Hr"};